















import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'GSquareWhiteButtonWithBorder',
  props: {
    to: String as PropType<string>,
    imageUrl: String as PropType<string>,
    blank: {
      type: Boolean as PropType<boolean>,
      default: false,
      required: false,
    },
  },
});
